const YES_VALUES = new Set(["yes", "y", "true", "1"]);
const NO_VALUES = new Set(["no", "n", "false", "0"]);

export function normalizeLookupSecurityExistence(value) {
    const raw = String(value ?? "").trim().toLowerCase();
    if (!raw) return "";
    if (YES_VALUES.has(raw)) return "yes";
    if (NO_VALUES.has(raw)) return "no";
    return "";
}

export function getLookupSecurityExistenceFromPayload(payload) {
    if (!payload || typeof payload !== "object") return "";

    return normalizeLookupSecurityExistence(
        payload.isSecExist ??
        payload.isSecurityExist ??
        payload.secExist ??
        payload.response?.isSecExist ??
        payload.response?.isSecurityExist ??
        payload.response?.secExist
    );
}
